export { default } from './SpecialNavigation';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Header/SpecialNavigation/index.js